// StartupSlider.jsx
import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import WordpressHosting from "../Pages/Hosting/WordpressHosting";

    const cardData = [
        {
            title: "Automatic Update, Always Ahead",
            image: "images/automatic-update.webp",
            description: "Remain in the lead with automatic and daily WordPress updates. We make sure that your website is always enhanced, and live."
        }, 
        {
            title: "Flawless Website Management",
            image: "images/Flawless Website Management.webp",
            description: "Gain access with SFTP and SSH, guaranteeing secure and productive management. WP-CLI streamlines all admin tasks."
        }, 
        {
            title: "Performance-Powered Hosting",
            image: "images/performance-powerd.webp",
            description: "With LiteSpeed servers and Apache, RAID 10 configuration, and SSD NVMe storage, your site gets reliable performance."
        }, 
        {
            title: "WordPress Staging for Testing",
            image: "images/wordpress-staging.webp",
            description: "Flawlessly make a clone of your WordPress site, try innovative features or updates, and make all of them live once you're ready."
        }, 
        {
            title: "Advanced WordPress Management",
            image: "images/advanced-wordpress.webp",
            description: "Activate, deactivate, install, or get both themes and plugins directly from WordPress’s official website-whether separately or in bulk."
        }, 
        {
            title: "Preconfigured WordPress for Setup",
            image: "images/preconfigured-wordpress.webp",
            description: "Skip manual WordPress installation. As soon as you buy our WordPress plan, we simply set up WordPress for you as per your business needs."
        },
        {
            title: "WordPress Hosting, Simplified",
            image: "images/wordpress-staging.webp",
            description: "Power, safety, and optimal performance—customized especially for your growing WordPress-based website!"
        }, 
        {
            title: "CDN for Worldwide Reach, 24/7",
            image: "images/cdn-for-worldwide.webp",
            description: "Boost your site’s speed and availability with our in-built CDN, ensuring a seamless experience for site visitors globally."
        }, 
        {
            title: "HTTPS for Unbeatable Security",
            image: "images/https-for-unbeatable.webp",
            description: "Your site’s security is our #1st priority! All WordPress sites comes with automatic HTTPS, which improves rankings."
        }, 
        {
            title: "Secure and Expert-Level Email",
            image: "images/secure-and-expert.webp",
            description: "Our WordPress hosting consists of secure email along with SSL encryption, two-step verification, and an intuitive webmail interface."
        }
    ];

const StartupSlider = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [swiper, setSwiper] = useState(null);

  useEffect(() => {
    if (swiper && prevRef.current && nextRef.current) {
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.init();
      swiper.navigation.update();
    }
  }, [swiper]);

  return (
    <section className="pt-100 pb-100">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-8">
            <div className="text-center">
              <h3 className="mb-8">Seamless & Stress-Free WordPress Management</h3>
              <p className="mt-3 mb-6">Manage, update, and clone your website flawlessly with our managed WordPress hosting-where simplicity meets performance!</p>
            </div>
          </div>
        </div>

        {/* SLIDER */}
        <div className="feedback-slider swiper">
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={30}
            slidesPerView={3}
            loop={true}
            speed={1200}
            autoplay={{ delay: 1500 }}
            onSwiper={setSwiper}
            breakpoints={{
              0: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1200: { slidesPerView: 3 },
            }}
          >
            {cardData.map((item, index) => (
                <SwiperSlide>
                    <div className="bg-white p-7 shadow-sm rounded-3">
                        <h6 className="text-black fw-bold mb-3">{item.title}</h6>
                        <img src={item.image} alt="icon" className="img-fluid mb-3" />
                        <p className="text-black text-opacity-75 mb-0">{item.description} </p>
                    </div>
                </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="feedback-navs d-flex align-items-center justify-content-between position-relative w-100 z-2 d-none d-md-flex">
          <span
            className="feedback-button-next w-10 h-10 rounded-circle bg-dark d-flex align-items-center justify-content-center text-white"
            ref={nextRef}
          >
            <i className="fa-solid fa-angle-right"></i>
          </span>

          <span
            className="feedback-button-prev w-10 h-10 rounded-circle bg-dark d-flex align-items-center justify-content-center text-white"
            ref={prevRef}
          >
            <i className="fa-solid fa-angle-left"></i>
          </span>
        </div>
      </div>
    </section>
  );
};

export default StartupSlider;
